<main class="mobile-navbar">
    <!-- Sticky Glass Top Bar -->
    <nav class="navbar">
        <div class="nav-left">
            <button class="navbar-toggler" type="button" (click)="toggleCollapse()" [class.active]="isMenuOpen"
                aria-label="Toggle navigation">
                <span class="toggler-icon" *ngIf="!isMenuOpen">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                        stroke-linecap="round" stroke-linejoin="round">
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <line x1="3" y1="12" x2="21" y2="12"></line>
                        <line x1="3" y1="18" x2="21" y2="18"></line>
                    </svg>
                </span>
                <span class="toggler-icon close-icon" *ngIf="isMenuOpen">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                        stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </span>
            </button>

            <!-- Cinema Brand Logo -->
            <a class="nav-brand" routerLink="/" (click)="closeMenu()">
                <img class="mobile-logo-img" src="/assets/images/icon.png" alt="Cinema">
            </a>
        </div>

        <div class="nav-actions">
            <app-language-selector></app-language-selector>

            <!-- Profile Dropdown or Get Started -->
            <a *ngIf="!authToken || !userDetails" routerLink="/auth" class="btn-get-started" (click)="closeMenu()">
                {{ languageService.t('getStarted') }}
            </a>

            <div class="profile-dropdown-wrapper" *ngIf="authToken && userDetails"
                (mouseleave)="showProfileDropdown = false">
                <button class="profile-trigger" (click)="showProfileDropdown = !showProfileDropdown"
                    aria-label="User Profile">
                    <img #profileImage class="profile-image"
                        [src]="userDetails?.profile_picture || '/assets/images/avatar.png'"
                        [alt]="userDetails?.name || 'Profile'" (error)="onImageError($event)">
                </button>
                <div class="profile-dropdown" *ngIf="showProfileDropdown">
                    <div class="profile-dropdown-header">
                        <img class="dropdown-avatar" [src]="userDetails?.profile_picture || '/assets/images/avatar.png'"
                            (error)="onImageError($event)" alt="">
                        <div class="dropdown-user-info">
                            <span class="dropdown-name">{{ userDetails?.name }}</span>
                            <span class="dropdown-email">{{ userDetails?.email }}</span>
                        </div>
                    </div>
                    <div class="profile-dropdown-divider"></div>
                    <a class="profile-dropdown-item" [routerLink]="['/u', profileNameFilter(userDetails?.name || '')]"
                        (click)="showProfileDropdown = false; closeMenu()">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                            <circle cx="12" cy="7" r="4" />
                        </svg>
                        <span>{{ languageService.t('myProfile') }}</span>
                    </a>
                    <a class="profile-dropdown-item" [routerLink]="['/u', profileNameFilter(userDetails?.name || '')]"
                        [queryParams]="{edit: true}" (click)="showProfileDropdown = false; closeMenu()">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                        </svg>
                        <span>{{ languageService.t('editProfile') }}</span>
                    </a>
                    <div class="profile-dropdown-divider"></div>
                    <button class="profile-dropdown-item logout" (click)="logout()">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                            <polyline points="16 17 21 12 16 7" />
                            <line x1="21" y1="12" x2="9" y2="12" />
                        </svg>
                        <span>{{ languageService.t('logout') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </nav>

    <!-- Slide-over Mobile Navigation Drawer Overlay -->
    <div #navbarCollapse class="mobile-drawer-overlay" [class.open]="isMenuOpen" (click)="closeMenu()">
        <!-- Drawer Panel -->
        <aside class="mobile-drawer-sheet" (click)="$event.stopPropagation()">
            <!-- Drawer Brand Header -->
            <div class="drawer-header">
                <div class="drawer-brand">
                    <div class="brand-icon-box">
                        <img class="drawer-logo" src="/assets/images/icon.png" alt="Cinema">
                    </div>
                    <div class="drawer-brand-text">
                        <span class="drawer-brand-title">THE SCENETALE</span>
                    </div>
                </div>
                <button class="drawer-close-btn" type="button" (click)="closeMenu()" aria-label="Close menu">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                        stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
            </div>

            <!-- Drawer Scrollable Content -->
            <div class="drawer-body">
                <!-- Group 1: Navigation -->
                <div class="drawer-group">
                    <span class="group-label">EXPLORE</span>

                    <!-- Home -->
                    <a class="drawer-nav-item" routerLink="/" routerLinkActive="active"
                        [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()">
                        <div class="item-icon-box">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                                <polyline points="9 22 9 12 15 12 15 22" />
                            </svg>
                        </div>
                        <span class="item-text">{{ languageService.t('home') }}</span>
                    </a>

                    <!-- Movie Accordion -->
                    <div class="drawer-accordion" [class.expanded]="expandedSection === 'movie'">
                        <button class="drawer-accordion-btn" type="button" (click)="toggleSection('movie')">
                            <div class="item-icon-box">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2">
                                    <rect width="20" height="20" x="2" y="2" rx="2.18" ry="2.18" />
                                    <line x1="7" y1="2" x2="7" y2="22" />
                                    <line x1="17" y1="2" x2="17" y2="22" />
                                    <line x1="2" y1="12" x2="22" y2="12" />
                                    <line x1="2" y1="7" x2="7" y2="7" />
                                    <line x1="2" y1="17" x2="7" y2="17" />
                                    <line x1="17" y1="7" x2="22" y2="7" />
                                    <line x1="17" y1="17" x2="22" y2="17" />
                                </svg>
                            </div>
                            <span class="item-text">{{ languageService.t('movie') }}</span>
                            <svg class="chevron" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2.5">
                                <path d="m6 9 6 6 6-6" />
                            </svg>
                        </button>
                        <div class="drawer-submenu" *ngIf="expandedSection === 'movie'">
                            <a class="drawer-subitem" [routerLink]="['/movies/popular']" routerLinkActive="active"
                                (click)="closeMenu()">
                                <div class="subitem-content">
                                    <span class="subitem-title">{{ languageService.t('popular') }}</span>
                                    <span class="subitem-desc">Hollywood &amp; trending</span>
                                </div>
                            </a>
                            <a class="drawer-subitem" [routerLink]="['/movies/now-playing']" routerLinkActive="active"
                                (click)="closeMenu()">
                                <div class="subitem-content">
                                    <span class="subitem-title">{{ languageService.t('nowPlaying') }}</span>
                                    <span class="subitem-desc">In theatres now</span>
                                </div>
                            </a>
                            <a class="drawer-subitem" [routerLink]="['/movies/upcoming']" routerLinkActive="active"
                                (click)="closeMenu()">
                                <div class="subitem-content">
                                    <span class="subitem-title">{{ languageService.t('upcoming') }}</span>
                                    <span class="subitem-desc">Anticipated releases</span>
                                </div>
                            </a>
                            <a class="drawer-subitem" [routerLink]="['/movies/top-rated']" routerLinkActive="active"
                                (click)="closeMenu()">
                                <div class="subitem-content">
                                    <span class="subitem-title">{{ languageService.t('topRated') }}</span>
                                    <span class="subitem-desc">All-time highest rated</span>
                                </div>
                            </a>
                        </div>
                    </div>

                    <!-- TV Shows Accordion -->
                    <div class="drawer-accordion" [class.expanded]="expandedSection === 'tv'">
                        <button class="drawer-accordion-btn" type="button" (click)="toggleSection('tv')">
                            <div class="item-icon-box">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2">
                                    <rect width="20" height="15" x="2" y="7" rx="2" ry="2" />
                                    <polyline points="17 2 12 7 7 2" />
                                </svg>
                            </div>
                            <span class="item-text">{{ languageService.t('tv') }}</span>
                            <svg class="chevron" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2.5">
                                <path d="m6 9 6 6 6-6" />
                            </svg>
                        </button>
                        <div class="drawer-submenu" *ngIf="expandedSection === 'tv'">
                            <a class="drawer-subitem" [routerLink]="['/tv/popular']" routerLinkActive="active"
                                (click)="closeMenu()">
                                <div class="subitem-content">
                                    <span class="subitem-title">{{ languageService.t('popular') }}</span>
                                    <span class="subitem-desc">Trending television</span>
                                </div>
                            </a>
                            <a class="drawer-subitem" [routerLink]="['/tv/airing-today']" routerLinkActive="active"
                                (click)="closeMenu()">
                                <div class="subitem-content">
                                    <span class="subitem-title">{{ languageService.t('airingToday') }}</span>
                                    <span class="subitem-desc">Episodes on today</span>
                                </div>
                            </a>
                            <a class="drawer-subitem" [routerLink]="['/tv/on-the-air']" routerLinkActive="active"
                                (click)="closeMenu()">
                                <div class="subitem-content">
                                    <span class="subitem-title">{{ languageService.t('onTheAir') }}</span>
                                    <span class="subitem-desc">Currently broadcasting</span>
                                </div>
                            </a>
                            <a class="drawer-subitem" [routerLink]="['/tv/top-rated']" routerLinkActive="active"
                                (click)="closeMenu()">
                                <div class="subitem-content">
                                    <span class="subitem-title">{{ languageService.t('topRated') }}</span>
                                    <span class="subitem-desc">Critically acclaimed</span>
                                </div>
                            </a>
                        </div>
                    </div>

                    <!-- People Accordion -->
                    <div class="drawer-accordion" [class.expanded]="expandedSection === 'person'">
                        <button class="drawer-accordion-btn" type="button" (click)="toggleSection('person')">
                            <div class="item-icon-box">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2">
                                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                    <circle cx="9" cy="7" r="4" />
                                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                </svg>
                            </div>
                            <span class="item-text">{{ languageService.t('person') }}</span>
                            <svg class="chevron" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2.5">
                                <path d="m6 9 6 6 6-6" />
                            </svg>
                        </button>
                        <div class="drawer-submenu" *ngIf="expandedSection === 'person'">
                            <a class="drawer-subitem" [routerLink]="['/person/popular']" routerLinkActive="active"
                                (click)="closeMenu()">
                                <div class="subitem-content">
                                    <span class="subitem-title">{{ languageService.t('popularPeople') }}</span>
                                    <span class="subitem-desc">Hollywood stars &amp; creators</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Group 2: Community & Experiences -->
                <div class="drawer-group">
                    <span class="group-label">EXPERIENCES</span>

                    <!-- Trivia -->
                    <a class="drawer-nav-item" routerLink="/quiz" routerLinkActive="active" (click)="closeMenu()">
                        <div class="item-icon-box trivia-icon">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <polygon
                                    points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                            </svg>
                        </div>
                        <span class="item-text">{{ languageService.t('trivia') }}</span>
                    </a>

                    <!-- Blogs -->
                    <a class="drawer-nav-item" routerLink="/blogs" routerLinkActive="active" (click)="closeMenu()">
                        <div class="item-icon-box blog-icon">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1-2.5-2.5Z" />
                                <path d="M6 6h10" />
                                <path d="M6 10h10" />
                            </svg>
                        </div>
                        <span class="item-text">{{ languageService.t('blogs') }}</span>
                    </a>

                    <!-- Calendar -->
                    <a class="drawer-nav-item" routerLink="/scenetale-calendar" routerLinkActive="active"
                        (click)="closeMenu()">
                        <div class="item-icon-box calendar-icon">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                <line x1="16" y1="2" x2="16" y2="6" />
                                <line x1="8" y1="2" x2="8" y2="6" />
                                <line x1="3" y1="10" x2="21" y2="10" />
                            </svg>
                        </div>
                        <span class="item-text">Calendar</span>
                    </a>
                </div>

                <!-- Group 3: Account Card -->
                <div class="drawer-account-section">
                    <div *ngIf="authToken && userDetails" class="drawer-user-card">
                        <div class="user-card-header">
                            <img class="user-card-avatar"
                                [src]="userDetails?.profile_picture || '/assets/images/avatar.png'"
                                (error)="onImageError($event)" alt="User Avatar">
                            <div class="user-card-info">
                                <span class="user-card-name">{{ userDetails?.name }}</span>
                                <span class="user-card-email">{{ userDetails?.email }}</span>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="!authToken || !userDetails" class="drawer-guest-card">
                        <div class="guest-card-title">Join The Scenetale</div>
                        <p class="guest-card-desc">Track cinema, play daily trivia, and build your bespoke movie
                            archive.</p>
                        <a routerLink="/auth" class="guest-cta-btn" (click)="closeMenu()">
                            <span>{{ languageService.t('getStarted') }}</span>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2.2">
                                <line x1="5" y1="12" x2="19" y2="12" />
                                <polyline points="12 5 19 12 12 19" />
                            </svg>
                        </a>
                    </div>
                </div>

                <!-- Drawer Micro Footer -->
                <div class="drawer-footer">
                    <span>The Scenetale © 2026 • Built for Cinephile</span>
                </div>
            </div>
        </aside>
    </div>
</main>